import { scrollbarStyle } from '@blocksuite/affine-shared/styles';
import { unsafeCSSVar, unsafeCSSVarV2 } from '@blocksuite/affine-shared/theme';
import { baseTheme } from '@toeverything/theme';
import { css, unsafeCSS } from 'lit';

export const styles = css`
  .overlay-mask {
    pointer-events: auto;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: var(--affine-z-index-popover);
  }

  .slash-menu {
    position: fixed;
    left: 0;
    top: 0;
    box-sizing: border-box;
    padding: 8px 4px 8px 8px;
    width: 280px;
    overflow-y: auto;
    font-family: ${unsafeCSS(baseTheme.fontSansFamily)};

    background: ${unsafeCSSVarV2('layer/background/overlayPanel')};
    box-shadow: ${unsafeCSSVar('overlayPanelShadow')};
    border-radius: 8px;
    z-index: var(--affine-z-index-popover);
    user-select: none;
    /* transition: max-height 0.2s ease-in-out; */
  }

  ${scrollbarStyle('.slash-menu')}

  .slash-menu-group-name {
    box-sizing: border-box;
    padding: 2px 8px;

    font-size: var(--affine-font-xs);
    font-weight: 500;
    line-height: var(--affine-line-height);
    text-align: left;
    color: var(
      --light-textColor-textSecondaryColor,
      var(--textColor-textSecondaryColor, #8e8d91)
    );
  }

  .slash-menu-item {
    padding: 2px 8px 2px 8px;
    justify-content: flex-start;
    gap: 10px;
  }

  .slash-menu-item-icon {
    box-sizing: border-box;
    width: 28px;
    height: 28px;
    padding: 4px;
    border: 1px solid var(--affine-border-color, #e3e2e4);
    border-radius: 4px;
    color: var(--affine-icon-color);
    background: ${unsafeCSSVarV2('layer/background/overlayPanel')};

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .slash-menu-item-icon svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .slash-menu-item.ask-ai {
    color: var(--affine-brand-color);
  }
  .slash-menu-item.github .github-icon {
    color: var(--affine-black);
  }
`;

export const slashItemToolTipStyle = css`
  .affine-tooltip {
    display: flex;
    padding: 4px 4px 2px 4px;
    flex-direction: column;
    align-items: flex-start;
    gap: 3px;
  }

  .tooltip-figure svg {
    display: block;
  }

  .tooltip-caption {
    padding-left: 4px;
    color: var(
      --light-textColor-textSecondaryColor,
      var(--textColor-textSecondaryColor, #8e8d91)
    );
    font-family: var(--affine-font-family);
    font-size: var(--affine-font-xs);
    line-height: var(--affine-line-height);
  }
`;

export const mobileSlashMenuStyles = css`
  :host {
    height: 240px;
    width: 100%;
    position: fixed;
    left: 0;
    z-index: var(--affine-z-index-popover);
    overflow-y: auto;
    overscroll-behavior: contain;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;

    --border-style: 1px solid ${unsafeCSSVarV2('layer/insideBorder/border')};

    border-radius: 12px 12px 0px 0px;
    border-top: var(--border-style);
    border-right: var(--border-style);
    border-left: var(--border-style);
    background: ${unsafeCSSVarV2('layer/background/primary')};
    box-shadow: 0px -3px 10px 0px rgba(0, 0, 0, 0.07);
  }

  :host::-webkit-scrollbar {
    display: none;
  }

  .mobile-slash-menu-group-title {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 20px 4px;
    color: ${unsafeCSSVarV2('text/secondary')};
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
  }

  .mobile-slash-menu-item {
    display: flex;
    width: 100%;
    min-height: 52px;
    flex-shrink: 0;
    padding: 8px 20px;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    box-sizing: border-box;
    text-align: left;

    border: none;
    background: inherit;
  }

  .mobile-slash-menu-item > svg,
  .mobile-slash-menu-item .icon > svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: ${unsafeCSSVarV2('icon/primary')};
  }

  .mobile-slash-menu-item .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: ${unsafeCSSVarV2('icon/primary')};
  }

  .mobile-slash-menu-item .content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
  }

  .mobile-slash-menu-item .name {
    overflow: hidden;
    color: ${unsafeCSSVarV2('text/primary')};
    text-overflow: ellipsis;
    white-space: nowrap;

    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.43px;
  }

  .mobile-slash-menu-item .description {
    overflow: hidden;
    color: ${unsafeCSSVarV2('text/secondary')};
    text-overflow: ellipsis;
    white-space: nowrap;

    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
  }

  .mobile-slash-menu-item:active {
    background: ${unsafeCSSVarV2('layer/background/hoverOverlay')};
  }

  .mobile-slash-menu-empty {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 20px;
    color: ${unsafeCSSVarV2('text/secondary')};
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 15px;
  }
`;
